module.exports = __webpack_public_path__ + "41759918b872463b4c0efe06526a8309.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/itcavantgardestd-bold-webfont.ttf
 ** module id = 376
 ** module chunks = 0
 **/